import type { ChatMessage } from '../lib/chat-db';

export const applySmartMemoryLimit = (messages: ChatMessage[], limit: number): ChatMessage[] => {
  if (limit === 0 || messages.length <= limit) {
    return messages;
  }

  // For this implementation, all messages are conversation messages
  // (system prompts are handled at the API level, not stored in chat history)
  const conversationMessages = messages;

  if (conversationMessages.length <= limit) {
    return messages; // Everything fits
  }

  // Calculate distribution for conversation messages
  let beginningSize: number;
  let endSize: number;

  if (limit <= 10) {
    // For small limits, prioritize recent context
    beginningSize = Math.min(2, Math.floor(limit * 0.2)); // 20% or 2 messages max
    endSize = limit - beginningSize;
  } else if (limit <= 30) {
    // Medium limits: balanced approach
    beginningSize = Math.floor(limit * 0.25); // 25%
    endSize = limit - beginningSize;
  } else {
    // Large limits: preserve more beginning context
    beginningSize = Math.floor(limit * 0.3); // 30%
    endSize = limit - beginningSize;
  }

  // Ensure at least 1 message from each side
  beginningSize = Math.max(1, beginningSize);
  endSize = Math.max(1, endSize);

  const beginning = conversationMessages.slice(0, beginningSize);
  const ending = conversationMessages.slice(-endSize);

  // Combine: beginning + ending
  return [...beginning, ...ending];
};
